module.exports = __webpack_public_path__ + "static/assets/73773f78bf2bfc449218fbaee1922964.svg";